import React from "react";
import { Row, Col, Space, Tooltip, message, Button, Modal, Image, Drawer } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import { CloseOutlined } from "@ant-design/icons";

import { Link } from "react-router-dom";
import FAQStore from "../store/FAQListStore";
import FAQAdd from "./FAQAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
class FAQList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.faqStore = new FAQStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      Id: '',
      openfaqForm: false,
      openDeleteModal: false,
      deleteData: {},
      editData: {},
    };
    this.columns = [
      {
        title: context.translate("_QUESTION_"),
        dataIndex: "question",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_ANSWER_"),
        dataIndex: "answer",
        width: 20,
        ellipsis: {
          showTitle: true,
        }
      },
      {
        title: context.translate("_FLEET_DASHBORD_SETTING_DATE_"),
        dataIndex: "dateTime",
        width: 10,
        ellipsis: {
          showTitle: true,
        }
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 5,
        align: 'center',
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                <Tooltip
                                  title={this.context.translate("_EDIT_")}
                                  placement="bottom"
                                >
                <Image
                  style={{
                    height: "19px",
                    width: "14px",
                    borderRadius: "0px",
                    cursor: "pointer",
                  }}
                  src={editIcon}
                  onClick={async (e) => {
                    e.preventDefault();
                    await this.onEdit(record);
                  }}
                ></Image>
                </Tooltip>
                <Tooltip
                                  title={this.context.translate("_DELETE_")}
                                  placement="bottom"
                                >
                <Image
                  src={require("../assets/images/NewDesign/Delete.png")}
                  style={{ cursor: "pointer", width: "14px" }}
                  onClick={() =>
                    this.setState({
                      openDeleteModal: true,
                      deleteData: record,
                    })
                  }
                ></Image>
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ];
  }
  async componentDidMount() {
    await this.handleSearch();
    this.setState({ pageSize: 50 });


  }

  onEdit = async (record) => {
    await this.setState({ Id: record.Id });
    await this.setState({ openfaqForm: true });
  };

  async onDelete(record) {
    const response = await this.faqStore.deleteRecord({
      Id: record.Id,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.faqStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      page: this.state.currentPage,
    });
    await this.setState({ loadData: 1, loading: false });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  closeModal = () => {
    this.setState({ openfaqForm: false });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ openfaqForm: false });
      await this.handleSearch();
    }
  };
  refreshList = async () => {

    this.setState({ loading: true });
    await this.faqStore.loadData({
      offset: 0,
      limit: 50,

    });
    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={24}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>


              <Button
                className="addButtonClass"
                onClick={() =>
                  this.setState({ openfaqForm: true, Id: "" })
                }
              >
                <Image
                  style={{ width: 13 ,marginInlineEnd: "5px"}}//marginInlineEnd: "5px",
                  src={require("../assets/images/NewDesign/plus (Stroke).png")}
                ></Image>
                {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
              </Button>

            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.faqStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.faqStore?.faqList}
            loading={this.faqStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openfaqForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openfaqForm}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_FAQ_DETAIL_")}
                <p className="formDescription">
                  {this.context.translate("_FAQ_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openfaqForm: false })}
            onCancel={() =>
              this.setState({ openfaqForm: false, Id: "" })
            }
          >
            <div style={{ height: '100%' }}>
              <FAQAdd
                Id={this.state.Id}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>

    );
  }
}
FAQList.contextType = StoreContext;
export default observer(withRouter(FAQList));
